export const UnsavedChangesStorageKey = 'unsaved-changes';
